import type { Colors } from '../../constants/theme';
import { MidnightContestWizard } from './contestWizard/MidnightContestWizard';

export interface BrandNewContestFormProps {
    themeColors: Colors;
}

/** Midnight Editorial stepped contest creation (dev-enabled via brandCampaignConfig). */
export function BrandNewContestForm({ themeColors }: BrandNewContestFormProps) {
    return <MidnightContestWizard themeColors={themeColors} />;
}
